import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class BakeryConfigurationSeasonalDiscountActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Bakery/SeasonalDiscount/SeasonalDiscountBrowser")
	}

	render() {
		return (
			<Activity 
				name="SeasonalDiscount"
				RenderedComponent={this.RenderedComponent}
				context="SeasonalDiscount"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(BakeryConfigurationSeasonalDiscountActivity)
